import React from 'react';

/**
 * Owner-account panel. Two states:
 *   • Owner row exists → show name/email/phone + reset + resend-creds.
 *   • No owner yet → show inline "Create owner account" invite form.
 *
 * The Master Admin can invite a fresh shop_admin here without going
 * through the full onboarding wizard — useful when they're taking
 * over a shop that lost its owner login.
 */
export const OwnerPanel = ({
  owner, ownerBusy, ownerMsg,
  showInvite, setShowInvite,
  inviteEmail, setInviteEmail,
  inviteName, setInviteName,
  onInvite, onSendReset, onResendCredentials,
}) => (
  <div className="panel" data-testid="shop-owner-panel">
    <div className="ph"><h3>Owner account</h3></div>
    {owner ? (
      <>
        <div className="infrow"><span className="k">Name</span><span className="vv" data-testid="owner-name">{owner.name}</span></div>
        <div className="infrow">
          <span className="k">Email</span>
          <span className="vv" data-testid="owner-email">
            {owner.email ? (
              <a href={`mailto:${owner.email}`}>{owner.email}</a>
            ) : <span style={{ color: 'var(--mute)' }}>—</span>}
          </span>
        </div>
        <div className="infrow">
          <span className="k">Contact number</span>
          <span className="vv" data-testid="owner-phone">
            {owner.phone ? (
              <a href={`tel:${owner.phone.replace(/\s+/g, '')}`}>{owner.phone}</a>
            ) : <span style={{ color: 'var(--mute)' }}>—</span>}
          </span>
        </div>
        <div style={{ padding: 14, display: 'flex', gap: 10 }}>
          <button className="btn s" disabled={ownerBusy} onClick={onSendReset} data-testid="owner-send-reset">
            {ownerBusy ? 'Sending…' : 'Send password reset'}
          </button>
          <button className="btn s" disabled={ownerBusy} onClick={onResendCredentials} data-testid="owner-resend-credentials" style={{ marginLeft: 6 }}>
            Resend credentials
          </button>
        </div>
      </>
    ) : (
      <>
        <div style={{ padding: 14, color: 'var(--text-mute)', fontSize: 'var(--fs-base)' }}>
          No owner account yet. Create one so the shop can sign in.
        </div>
        <div style={{ padding: 14 }}>
          {!showInvite ? (
            <button className="btn s" onClick={() => setShowInvite(true)} data-testid="owner-create-btn">
              Create owner account
            </button>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <input
                className="inp" placeholder="Owner email" type="email"
                value={inviteEmail} onChange={(e) => setInviteEmail(e.target.value)}
                data-testid="owner-invite-email"
              />
              <input
                className="inp" placeholder="Owner name (optional)"
                value={inviteName} onChange={(e) => setInviteName(e.target.value)}
                data-testid="owner-invite-name"
              />
              <div style={{ display: 'flex', gap: 8 }}>
                <button
                  className="btn s g"
                  disabled={!inviteEmail.trim() || ownerBusy}
                  onClick={onInvite} data-testid="owner-invite-submit"
                >
                  {ownerBusy ? 'Inviting…' : 'Send invite'}
                </button>
                <button className="btn s" onClick={() => setShowInvite(false)} disabled={ownerBusy}>
                  Cancel
                </button>
              </div>
            </div>
          )}
        </div>
      </>
    )}
    {ownerMsg && (
      <div style={{ padding: 14, fontSize: 'var(--fs-sm)', color: ownerMsg.startsWith('Failed') ? 'var(--danger)' : 'var(--text-body)' }} data-testid="owner-msg">
        {ownerMsg}
      </div>
    )}
  </div>
);
